import { Attachment, Button, Col, Row, SearchInput, Slider } from "@kaleyra/emmy";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Styles from './index.module.scss';
import { UploadDocumentResponseType } from '../senderIdApplyForm';

type SelfProps = {
    documentList: Array<DocumentType>;
    onClose: () => void;
    setSelectedDocuments: (selectedDoc: Array<UploadDocumentResponseType>) => void;
}

export type DocumentType = {
    created_at: string;
    id: number;
    size: string;
    title: string;
    url: string;
}

const UploadedDocuments: React.FC<SelfProps> = ({ documentList, onClose, setSelectedDocuments }) => {
    const { t } = useTranslation();

    const [searchText, setSearchText] = useState('');
    const [selectedDocumentList, setSelectedDocumentList] = useState<Array<DocumentType>>([]);
    const [filteredDocumentList, setFilteredDocumentList] = useState<Array<DocumentType>>([]);

    useEffect(() => {
        let filteredList = documentList.filter((item: DocumentType) => (item.title).toLowerCase().includes(searchText.toLowerCase()));
        setFilteredDocumentList(filteredList);
    }, [searchText])

    const getSelectedStatus = (id: number): boolean => {
        const list = selectedDocumentList.find((document: DocumentType) => document.id === id);
        return Boolean(list);
    }

    const onSelectDocument = (checked: boolean, document: DocumentType) => {
        let sel = [...selectedDocumentList];
        if (checked) {
            sel.push(document);
        } else {
            sel = sel.filter((doc: DocumentType) => doc.id !== document.id);
        }
        setSelectedDocumentList(sel);
    }

    const getBody = () => {
        return <>
            <Row>
                <Col size={12}>
                    <SearchInput
                        label={t('searchDocuments')}
                        placeholder={t('searchDocuments')}
                        eachChar={true}
                        style={{ width: '22rem' }}
                        value={searchText}
                        searchStr={searchText}
                        onChange={(e: any) => setSearchText(e)} />
                </Col>
            </Row >
            <Row>
                {
                    filteredDocumentList.map((document: DocumentType, index: number) => {
                        const type = document.title.split('.').pop() || "";
                        return (
                            <Attachment
                                key={index}
                                checked={getSelectedStatus(document.id)}
                                onCheckBoxClick={(e: any) => onSelectDocument(e.target.checked, document)}
                                fileName={document.title}
                                fileUrl={document.url}
                                id={document.id}
                                fileType={type}
                                download={true}
                                closable={false} />
                        )


                    })
                }
            </Row>
        </>
    }

    const addDocuments = () => {
        let selectedDocumentsFormatted: Array<UploadDocumentResponseType> = [];
        selectedDocumentList.forEach((selDocuments: DocumentType) => {
            let formattedList = {
                company_id: "",
                description: "",
                file_format: "",
                id: selDocuments.id,
                size: selDocuments.size,
                status: "",
                title: selDocuments.title,
                uploaded_by: "",
                url: selDocuments.url
            }
            selectedDocumentsFormatted.push(formattedList);
        });
        setSelectedDocuments(selectedDocumentsFormatted);
        onClose();
    }

    const getFooter = (): React.ReactNode => {
        return (
            <div className={Styles.flexEnd}>
                <Button type="tertiary" className={Styles.cancelBtn} onClick={onClose}>
                    {t('mainCancel')}
                </Button>
                <Button type="primary" onClick={() => addDocuments()} disabled={documentList.length === 0}>
                    {t('flwAdd')}
                </Button>
            </div>
        );
    };

    return (<Slider
        containerId="root-modal"
        onClose={onClose}
        visibility={true}
        title={t('selDoc')}
        footer={getFooter()}
    >
        <div className={Styles.container}>{getBody()}</div>
    </Slider>)
}

export default UploadedDocuments;